import React from 'react'
import { ReactComponent as IconArrowRight } from 'images/arrow-right.svg';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import styles from 'modules/hashtags/pages/Hashtags/Hashtags.module.scss'
import Skeleton from 'components/shared/Skeleton';

type Props = {
  data: any,
  loading?: boolean,
}

export default function HashtagsTable({ data, loading }: Props) {
  if (loading && !data?.length) {
    return (
      <div className={styles.hashtags}>
        {Array.from(Array(10).keys()).map((item: number) => (
          <Skeleton
            key={item}
            className={styles.hashtagsItem}
          />
        ))}
      </div>
    )
  }

  if (!data?.length) {
    return null
  }

  return (
    <div className={clsx(
      styles.hashtags,
      loading && styles.hashtags_loading,
    )}
    >
      {data?.map((hashtag) => (
        <div className={styles.hashtagsItem} key={hashtag?.objectID}>
          <div className={styles.nameBlock}>
            <span className={styles.nameBlockIcon}>#</span>
            <span className={styles.name}>{hashtag?.label}</span>
          </div>
          <div className={styles.countBlock}>
            <span className={styles.count}>{hashtag?.posts_count}</span>
            {' '}
            <span className={styles.countCaption}>Videos</span>
          </div>
          <div className={styles.arrowButton}>
            <IconArrowRight />
          </div>
          <Link className={styles.link} to={`/hashtags/${hashtag?.objectID}`} />
        </div>
      ))}
    </div>
  )
}
